//import { LoteDsItemComponent } from 'src/app/shared/lote-ds-item/lote-ds-item.component';
import { Component, EventEmitter, OnInit, Output, AfterViewInit, ComponentRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Sec002CardVComponent } from 'src/app/views/form-sec002/partialViews/sec002-card-V.component';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import Add from 'src/app/action/type.action';
import { SimpleModalComponent } from '../simple-modal/simple-modal.component';

@Component({
  selector: 'app-lote-ds-item',
  templateUrl: './lote-ds-item.component.html',

})
export class LoteDsItemComponent extends GeneralComponent implements OnInit {
  public formulario?: FormGroup;
  public parentRef: Sec002CardVComponent;
  public unique_key: number;
  public btnExcluir = false
  @Output() componentsReferences = Array<ComponentRef<LoteDsItemComponent>>()
  @Output() mkCalc = new EventEmitter<Number>();
  @Output() loteDsDeletedEmitter = new EventEmitter();


  sec002$: Observable<[]>;
  private result: number = 0.0;

  constructor(protected formularioService: FormularioService,
    protected formBuilder: FormBuilder,
    protected notificationService: NotificationService,
    protected generalService: GeneralService,
    public dialog: MatDialog,
    private add: Store<any>,) {
    super('', false);
    this.formulario = this.formBuilder.group({
      id: [null],
      Peso_debulha_kg: [null, []],
      Lote_ds: [null, [Validators.pattern('\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)|([a-zA-Z]{1}[0-9]{1}[a-zA-Z]{3}[0-9]{4})')]],// [null, [Validators.pattern('\^([a-zA-Z]{6}[0-9]{4})$|([a-zA-Z]{6}[0-9]{4}[;]{1})+([a-zA-Z]{6}[0-9]{4}[;]?)')]],
      Silo_destino: [null, [Validators.pattern('\^([S]{1}[B]{1}[0-9]{2})$|([S]{1}[B]{1}[0-9]{2}[;]{1})+([S]{1}[B]{1}[0-9]{2}[;]?)|([B]{1}[B]{1})')]]    //   null, [Validators.pattern('\^([S]{1}[B]{1}[0-9]{2})$|([S]{1}[B]{1}[0-9]{2}[;]{1})+([S]{1}[B]{1}[0-9]{2}[;]?)')]]

    });

  }


  ngOnInit(): void {
  }


  public remove(lastItem = false) {
    this.loteDsDeletedEmitter.emit();
    this.parentRef.removeLoteDsItemComponent(this.unique_key, lastItem);
    // this.componentsReferences.pop();
    this.calc();
  }


  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    this.addStore();
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  async makeCalculations(event): Promise<void> {
    this.calc()
  }

  private calc() {
    this.result = 0.0;
    this.componentsReferences.forEach((item, index) => {
      if (item.instance.formulario.controls.Peso_debulha_kg.value != null)
        this.result = this.result + parseFloat(item.instance.formulario.controls.Peso_debulha_kg.value);
    });
    this.mkCalc.emit(this.result);
  }


  addStore = () => {
    if (this.formulario.controls.Silo_destino.value !== null && this.componentsReferences.length === 1) {

      const clone = {
        form: this.formulario.controls.Silo_destino.value
      };

      this.add.dispatch(Add(clone.form));

    }
  }
  updateSilo = () => {
    this.loteDsDeletedEmitter.emit()
  }
  delete = () => {
    let input = {
      title: 'Excluír Lote DS',
      titleBtn1: 'Não',
      titleBtn2: 'Sim',
      mensage: `Deseja realmente excluír o Lote DS: ${this.formulario.get('Lote_ds')?.value as string ?? ''} ?`,
    };

    const dialogRef = this.dialog.open(SimpleModalComponent, {
      width: '600px',
      data: input,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.remove()
      }
    });
  }


}




